import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import EntityAvatar from 'theme/components/Avatar/EntityAvatar'
import { DensityStyleTypes } from '../../../../types'

interface RenderUserProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const RenderUserCell: React.FC<RenderUserProps> = ({ params, densityStyles }) => {
  const { owner } = params?.row ?? {}
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
      }}
    >
      <EntityAvatar
        name={owner?.name ?? null}
        photoUrl={owner?.image_512}
        size={densityStyles.size}
        showName={false}
        tooltip
      />
    </Box>
  )
}
export default RenderUserCell
